export default function Navigation() {
  return {
    open: false,
    toggle() {
      this.open = !this.open;
    }
  };
}
